import React, { memo } from 'react';
import { ThirtyText } from "@/app/components/texts";
import Chip from "@/app/components/chip";
import styles from './styles.module.scss';
import classNames from 'classnames';

interface Option<T> {
  value: T;
  label: string;
}

interface Props<T> {
  title: string;
  options: Option<T>[];
  selectedValue?: T;
  onSelect?: (value: T) => void;
  className?: string;
}

function SelectionWidget<T>({ 
  title, 
  options, 
  selectedValue, 
  onSelect, 
  className
}: Props<T>) {
  return (
    <div className={classNames(styles.selectionWidget, className)}>
      <ThirtyText text={title} />
      <div className={styles.chips}>
        {options.map((option) => (
          <Chip
            key={String(option.value)}
            text={option.label}
            isActive={selectedValue === option.value}
            onClick={() => onSelect?.(option.value)}
          />
        ))}
      </div>
    </div>
  );
}

export default memo(SelectionWidget) as typeof SelectionWidget;